export default function PadlockIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 47 46">
            <path fillRule="evenodd" d="M32.4 19.5H19.99v-4.16a4.45 4.45 0 0 1 8.7-1.26 1.78 1.78 0 0 0 3.13.55c.34-.45.44-1 .28-1.55a8.03 8.03 0 0 0-7.67-5.73c-4.4 0-8 3.6-8 8v4.15h-.92a2.69 2.69 0 0 0-2.68 2.67v11.8c0 1.48 1.2 2.69 2.68 2.69h16.9c1.48 0 2.69-1.2 2.69-2.68v-11.8c0-1.48-1.2-2.68-2.68-2.68Zm-7.32 8.38v3.46a1.13 1.13 0 0 1-2.26 0v-3.46a2.25 2.25 0 0 1 1.13-4.2 2.25 2.25 0 0 1 1.13 4.2Z" clipRule="evenodd"/>
        </svg>
    )
}


